import { create } from 'zustand';
import { countUnreadNotifications } from '@/services/social';

interface NotificationState {
  unread: number;
  loaded: boolean;
  /** Vuelve a contar. `null` cuando no hay sesión: deja el contador en cero. */
  refresh: (uid: string | null) => Promise<void>;
}

/**
 * Cuántas notificaciones sin leer tiene quien mira, para el punto rojo.
 *
 * Esto no existía. Las notificaciones se creaban bien y se listaban bien, pero
 * no había ningún indicador en el menú, así que la única forma de enterarse de
 * que alguien publicó un capítulo era entrar a la pantalla de notificaciones a
 * ver si había algo. Un aviso que hay que ir a buscar no es un aviso.
 *
 * Mismo patrón que el store de moderación, por los mismos motivos: vive en un
 * store compartido —para que marcar como leída apague el punto en el menú, no
 * sólo en la pantalla— y NO es en tiempo real. Una escucha abierta gastaría
 * lecturas todo el día; `getCountFromServer` cuesta una lectura cada mil
 * documentos, así que contar es prácticamente gratis.
 */
export const useNotificationStore = create<NotificationState>((set) => ({
  unread: 0,
  loaded: false,

  refresh: async (uid) => {
    if (!uid) {
      set({ unread: 0, loaded: true });
      return;
    }
    try {
      set({ unread: await countUnreadNotifications(uid), loaded: true });
    } catch {
      // Que el contador falle no puede romperle la navegación a nadie.
      set({ loaded: true });
    }
  },
}));
